import { render, staticRenderFns } from "./UnsolicitedNpcEffect.vue?vue&type=template&id=f39cf6f6&scoped=true&"
import script from "./UnsolicitedNpcEffect.vue?vue&type=script&lang=js&"
export * from "./UnsolicitedNpcEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39cf6f6",
  null
  
)

export default component.exports